export * from './version-widget/version-widget.component';
export * from './widgets.module';
